module.exports = __webpack_public_path__ + "assets/img/fe3f66dfcba492bd8539543caea5618b.svg";